import { FC, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { ProveedoresSalidasKPI } from "../ProveedoresInternosLayout/ProveedoresSalidas/ProveedoresSalidasKPI/ProveedoresSalidasKPI";
import './proveedoresexternoslayout.css'

export const ProveedoresExternosLayout:FC<any> = (props):JSX.Element => {

  const { kpisProveedoresExternos, comparativa, stateDonutExternos, stateEntradasProveedorExterno, filtered, tabID } = props

    const [state,setState] = useState<any>(stateDonutExternos)

    const [ state3, setState3 ] = useState<any>(stateEntradasProveedorExterno)
  
  return (
    <div className="proveedoresinternos-layout__wrapper"> 
        <div className="psalidas-top">
            <div className="psalidas-kpicontainer-ext" style={{height:'60%',border:'1px solid lightgray',borderRadius:5,marginRight:'1rem'}}>
              {
                kpisProveedoresExternos.map((kpi:any) => {
                  return (
                    <ProveedoresSalidasKPI title={kpi.title} valueA={kpi.valueA} valueB={kpi.valueB}
                    comparativa={comparativa} filtered={filtered} tabID={tabID} />
                  )
                })
              }
            </div>
            {
                  state.series.length === 0 || state.series.length === [0, 0].length && state.series.every((value:any, index:any) => value === [0, 0][index])?
                  <div className="donut-internos" style={{border:'1px solid lightgray',height:'100%'}}>
                    <span style={{fontFamily:'var(--roboto-light)',width:'60%',textAlign:'center'}}><i>[No existen datos para los filtros aplicados.]</i></span>
                  </div>
                  :
                  <ReactApexChart className="donut-internos" options={state.options} series={state.series} type="donut" height={'100%'}/>
                }
            
        </div>
        <div className="chart-of" style={{width:'100%',height:'60%'}}>
            <ReactApexChart options={state3?.options} series={state3?.series.map((s:any) => ({...s,data:s.data.map((d:any) => {if(d === 0) {
                    return 0.000001
                }
                return d
                })
                }))} type="bar" height={'100%'} />
        </div>
    </div>
  )
}